// extracted by mini-css-extract-plugin
export default {"xs":"CustomText_xs__lt9ae","sm":"CustomText_sm__y6brZ","lg":"CustomText_lg__NgW1S"};